import { Card, CardContent, CardHeader, Checkbox, FormControlLabel, Grid, Stack, Typography, ToggleButton, ToggleButtonGroup, Box } from "@mui/material";
import { GridView, List as ListIcon } from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import Tooltip from "../../../../../Components/Atoms/Tooltip";
import { ChangeEvent } from "react";

const PermissionConfiguration = (props: PermissionsFieldSetProps) => {
  const { permissionGroups } = props;

  const [view, setView] = useState<'grid' | 'list'>(() => {
    const saved = localStorage.getItem('permissionsView');
    return saved === 'list' || saved === 'grid' ? (saved as any) : 'grid';
  });

  useEffect(() => {
    localStorage.setItem('permissionsView', view);
  }, [view]);

  const togglePermission = (ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value;

    const newUserPermissions = [...props.userPermissions];

    const index = newUserPermissions.indexOf(value);

    if (index >= 0) {
      newUserPermissions.splice(index, 1);
    }
    else {
      newUserPermissions.push(value);
    }

    props.onChange(newUserPermissions);
  }

  return (
    <Card>
      <CardHeader
        title={'Permissões'}
        action={
          <ToggleButtonGroup
            size="small"
            exclusive
            value={view}
            onChange={(_, val) => val && setView(val)}
          >
            <Tooltip title="Visualizar em grade">
              <ToggleButton
                value="grid"
                aria-label="grade"
                sx={{
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'common.white',
                    '&:hover': { bgcolor: 'primary.dark' },
                  },
                }}
              >
                <GridView fontSize="small" color="inherit" />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="Visualizar em lista">
              <ToggleButton
                value="list"
                aria-label="lista"
                sx={{
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'common.white',
                    '&:hover': { bgcolor: 'primary.dark' },
                  },
                }}
              >
                <ListIcon fontSize="small" color="inherit" />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
        }
      />
      <CardContent>
        {view === 'grid' ? (
          <Stack gap={2} direction={'column'}>
            {permissionGroups.map(pg => (
              <div key={pg.group}>
                <Typography variant="h5">{pg.group}</Typography>
                <Grid container spacing={1}>
                  {pg.permissions.map(permission => (
                    <Grid key={permission.id} item xs={12} sm={6} md={4} lg={4} xl={4}>
                      <FormControlLabel
                        value={permission.id}
                        checked={props.userPermissions.includes(permission.id)}
                        control={<Checkbox sx={{ transform: 'scale(1.1)' }} />}
                        label={permission.name}
                        onChange={togglePermission}
                        labelPlacement='end'
                        sx={{ '& .MuiFormControlLabel-label': { fontSize: 16 } }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
          </Stack>
        ) : (
          <Stack gap={2} direction={'column'}>
            {permissionGroups.map(pg => (
              <div key={pg.group}>
                <Typography variant="h5">{pg.group}</Typography>
                <Stack gap={1} direction={'column'}>
                  {pg.permissions.map(permission => (
                    <Box key={permission.id}>
                      <FormControlLabel
                        value={permission.id}
                        checked={props.userPermissions.includes(permission.id)}
                        control={<Checkbox sx={{ transform: 'scale(1.1)' }} />}
                        label={permission.name}
                        onChange={togglePermission}
                        labelPlacement='end'
                        sx={{ '& .MuiFormControlLabel-label': { fontSize: 16 } }}
                      />
                    </Box>
                  ))}
                </Stack>
              </div>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  )
}

export { PermissionConfiguration };

